export const inspect = Symbol.for("nodejs.util.inspect.custom");
export type inspect = typeof inspect;
